<app-panel [caption]="'Ошибка 403'">
  <h5>Forbidden</h5>
  <p>Ключ авторизации отклонен</p>
</app-panel>
